<div class="tab-nav-overflow">
  <div class="tab-nav">
    <a (click)="showNavOptions = !showNavOptions" class="mobile-link">Menu</a>
    <ul [ngClass]=" showNavOptions ? 'nav-visible' : ''">
        <li *ngFor="let item of menuItems; let i=index"
        [ngClass]="{'selected': ((fullMatch && item.link == currentRoute) || (!fullMatch && currentRoute.includes(item.link) )), 'disabled': item.disabled, 'last': (i+1) == menuItems.length }">
          <em class="arrow-down"></em>
          <a class="link" [hidden]="item.disabled" [routerLink]="[item.link]" (click)="onClick(item)">
            <em>{{item.title}}</em>
          </a>
          <em [hidden]="!item.disabled">{{item.title}}</em>
          <span></span>
        </li>
    </ul>
  </div>
</div>